import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import type {
  FieldConfiguratorActor,
  FieldConfiguratorPreviewFilter,
  FieldConfiguratorPreviewMeta,
} from './field-configurator.models';

@Component({
  selector: 'app-field-preview-panel',
  imports: [CommonModule, FormsModule],
  templateUrl: './field-preview-panel.component.html',
  styleUrl: './field-preview-panel.component.scss',
})
export class FieldPreviewPanelComponent {
  @Input() actors: Array<FieldConfiguratorActor & { fieldCount: number }> = [];
  @Input() previewFilter: FieldConfiguratorPreviewFilter = 'all';
  @Input() previewMeta: FieldConfiguratorPreviewMeta = {};
  @Input() pageCount = 0;
  @Input() totalFields = 0;
  @Output() previewFilterChange = new EventEmitter<FieldConfiguratorPreviewFilter>();
  @Output() previewMetaChange = new EventEmitter<Partial<FieldConfiguratorPreviewMeta>>();
}
